import Props from "./props";
import styled from "styled-components";

const StyledForm = styled.form<Props>``;

export default StyledForm;
